
// Action: file_editor create /app/frontend/src/components/Footer.js --file-text "
import React from 'react';
import { Facebook, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#1A1A1A] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <h3 className="font-playfair text-2xl font-bold mb-4">
              Shree Ram Interior
            </h3>
            <p className="font-manrope text-sm tracking-widest text-[#D4AF37] mb-4">
              & GLASS WORKS
            </p>
            <p className="font-manrope text-sm text-gray-400 leading-relaxed">
              Designing elegant interiors and precision glass solutions with craftsmanship and quality.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-manrope text-sm tracking-widest uppercase mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {['Home', 'About', 'Portfolio', 'Testimonials', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase()}`}
                    data-testid={`footer-link-${item.toLowerCase()}`}
                    className="font-manrope text-sm text-gray-400 hover:text-[#D4AF37] transition-colors duration-300"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-manrope text-sm tracking-widest uppercase mb-6">
              Services
            </h4>
            <ul className="space-y-3 font-manrope text-sm text-gray-400">
              <li>Modular Kitchens</li>
              <li>Custom Wardrobes</li>
              <li>Glass Partitions</li>
              <li>False Ceilings</li>
              <li>Commercial Interiors</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-manrope text-sm tracking-widest uppercase mb-6">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={18} className="text-[#D4AF37] flex-shrink-0 mt-1" />
                <div>
                  <a
                    href="tel:+919599173367"
                    data-testid="footer-phone"
                    className="font-manrope text-sm text-gray-400 hover:text-[#D4AF37] transition-colors duration-300"
                  >
                    +91 95991 73367
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={18} className="text-[#D4AF37] flex-shrink-0 mt-1" />
                <a
                  href="mailto:mishivam22076@gmail.com"
                  data-testid="footer-email"
                  className="font-manrope text-sm text-gray-400 hover:text-[#D4AF37] transition-colors duration-300"
                >
                  mishivam22076@gmail.com"
                </a>
              </li>
              <li className="flex items-start gap-3"  href= "https://maps.app.goo.gl/v2Ab29kETvC6ekJo8">
              <MapPin size={18} className="text-[#D4AF37] flex-shrink-0 mt-1" /> 
               <a
                  href="https://maps.app.goo.gl/v2Ab29kETvC6ekJo8"
                  data-testid="footer-map"
                  className="font-manrope text-sm text-gray-400 hover:text-[#D4AF37] transition-colors duration-300"
                >
                  
                J-80, Street No. 8, 4th Pusta, Kartar Nagar, Delhi-53
                {/* <p className="font-manrope text-sm text-gray-400">
                  J-80, Street No. 8, 4th Pusta, Kartar Nagar, Delhi-53
                </p> */}
                </a>
                
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex gap-4 mt-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-facebook"
                className="p-2 border border-gray-600 rounded-full hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="p-2 border border-gray-600 rounded-full hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="font-manrope text-sm text-gray-400">
            © {new Date().getFullYear()} Shree Ram Interior & Glass Works. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
// Observation: Create successful: /app/frontend/src/components/Footer.js